import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5efd5f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "service-type-intro"
}
const _hoisted_2 = { class: "service-type-intro-item product-introduction" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jianjie" }),
  /*#__PURE__*/_createTextVNode("服务简介")
], -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "content",
  style: {"margin-top":"24px"}
}
const _hoisted_6 = {
  key: 0,
  class: "service-type-intro-item applicable-customer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "适用客户", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 1,
  class: "service-type-intro-item product-advantages"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fuwu" }),
  /*#__PURE__*/_createTextVNode("服务特点")
], -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 2,
  class: "service-type-intro-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-kaitong" }),
  /*#__PURE__*/_createTextVNode("服务开通")
], -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "opend-title" }
const _hoisted_16 = { class: "color-blue" }
const _hoisted_17 = { class: "mt-8" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 3,
  class: "service-type-intro-item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xinxi" }),
  /*#__PURE__*/_createTextVNode("开通信息")
], -1))
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 0,
  class: "mt-20"
}
const _hoisted_23 = {
  key: 4,
  class: "service-type-intro-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-yewu" }),
  /*#__PURE__*/_createTextVNode("业务流程")
], -1))
const _hoisted_25 = { class: "content" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 5,
  class: "service-type-intro-item"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shoufei" }),
  /*#__PURE__*/_createTextVNode("服务收费")
], -1))
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 6,
  class: "service-type-intro-item"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-zixun" }),
  /*#__PURE__*/_createTextVNode("咨询热线")
], -1))
const _hoisted_33 = { class: "content" }
const _hoisted_34 = {
  key: 7,
  class: "service-type-intro-item instructions-sending"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "注意事项", -1))
const _hoisted_36 = { class: "content" }
const _hoisted_37 = { class: "content-item-title" }
const _hoisted_38 = { class: "content-item-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    ref: "formDialogRefs",
    title: _ctx.formData.title,
    width: "1000px",
    hasFooter: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleRef) = $event))
  }, {
    default: _withCtx(() => [
      (_ctx.expressServiceDetail[_ctx.formData.pageUrl])
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.expressServiceDetail[_ctx.formData.pageUrl].introduction), 1),
              (_ctx.expressServiceDetail[_ctx.formData.pageUrl].introductions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].introductions, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].applicableCustomer &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].applicableCustomer.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].applicableCustomer, (item) => {
                      return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].advantages &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].advantages.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].advantages, (item) => {
                      return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].opened &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].opened.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].opened, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "mt-8"
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createTextVNode(_toDisplayString(item.title[0]), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(item.title[1]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.detail, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (typeof item == 'string')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(item), 1))
                                : (item.type=='img')
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 1,
                                      src: item.src
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].openedInfo
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].openedInfo.title, (title) => {
                        return (_openBlock(), _createElementBlock("p", { key: title }, _toDisplayString(title), 1))
                      }), 128))
                    ]),
                    (_ctx.expressServiceDetail[_ctx.formData.pageUrl].openedInfo.detail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].openedInfo.detail, (detail) => {
                            return (_openBlock(), _createElementBlock("p", { key: detail }, _toDisplayString(detail), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].process &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].process.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].process, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (typeof item == 'string')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(item), 1))
                          : (item.type=='img')
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 1,
                                src: item.src
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].charge &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].charge.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].charge, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (typeof item == 'string')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(item), 1))
                          : (item.type=='img')
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 1,
                                src: item.src
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].hotline
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.expressServiceDetail[_ctx.formData.pageUrl].hotline), 1)
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].attentions &&
          _ctx.expressServiceDetail[_ctx.formData.pageUrl].attentions.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressServiceDetail[_ctx.formData.pageUrl].attentions, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "content-item",
                        key: item.name
                      }, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (items, index) => {
                            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(index + 1) + "、" + _toDisplayString(items), 1))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}